import { jsx } from "react/jsx-runtime";
import { memo, Suspense } from "react";
import { useSelector } from "react-redux";
import { selectRegistrationSuccess } from "@nxplatform/geo-data/slices/ip-data.slice";
import { lazyImport } from "@nxplatform/helpers/helpers";
import { selectCustomerEntities } from "@nxplatform/store-shared/customer/shared-customer-selectors";
const { CallbackAfterRegistrationPrivate } = lazyImport(
  () => import("./callback-after-registration.private.js"),
  "CallbackAfterRegistrationPrivate"
);
const CallbackAfterRegistrationWrapper = () => {
  const {
    customer: { id },
    registrationSuccess
  } = useSelector((state) => ({
    customer: selectCustomerEntities(state),
    registrationSuccess: selectRegistrationSuccess(state)
  }));
  return !!id && registrationSuccess && /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(CallbackAfterRegistrationPrivate, {}) });
};
const _CallbackAfterRegistrationWrapper = memo(CallbackAfterRegistrationWrapper);
export {
  _CallbackAfterRegistrationWrapper as CallbackAfterRegistrationWrapper
};
